import React from 'react';
import { motion } from 'framer-motion';
import { User, Target, Heart } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  const steps = [{
    icon: <User className="w-8 h-8" data-id="element-107" />,
    titleKey: 'how.step1.title',
    descKey: 'how.step1.desc'
  }, {
    icon: <Target className="w-8 h-8" data-id="element-108" />,
    titleKey: 'how.step2.title',
    descKey: 'how.step2.desc'
  }, {
    icon: <Heart className="w-8 h-8" data-id="element-109" />,
    titleKey: 'how.step3.title',
    descKey: 'how.step3.desc'
  }];
  return <section id="how-it-works" className="py-32 bg-svt-bg-alt relative overflow-hidden transition-colors duration-300" data-id="element-110">
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02] pointer-events-none" data-id="element-111"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-24" data-id="element-113">
          <h2 className="text-4xl md:text-5xl font-bold text-svt-text" data-id="element-114">
            {t('how.title')}
          </h2>
        </motion.div>

        <div className="relative max-w-5xl mx-auto" data-id="element-115">
          <div className="hidden md:block absolute top-[4.5rem] left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-svt-pink/10 via-svt-purple/40 to-svt-pink/10 z-0" data-id="element-116">
            <motion.div className="absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-svt-pink shadow-[0_0_10px_#e84393]" animate={{
            left: ['0%', '100%']
          }} transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-117" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-118">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="flex flex-col items-center text-center group" data-id="element-119">
                <div className="relative mb-8" data-id="element-120">
                  <div className="absolute inset-0 bg-gradient-primary rounded-full blur-xl opacity-20 group-hover:opacity-50 transition-opacity duration-500" data-id="element-121"></div>
                  <div className="w-24 h-24 rounded-full bg-svt-bg border-2 border-svt-border flex items-center justify-center relative z-10 group-hover:border-svt-pink/50 transition-colors duration-500" data-id="element-122">
                    <div className="text-svt-text-muted group-hover:text-svt-text group-hover:scale-110 transition-all duration-500" data-id="element-123">
                      {step.icon}
                    </div>
                  </div>
                  <div className="absolute -bottom-2 -right-2 w-8 h-8 rounded-full bg-gradient-primary flex items-center justify-center text-sm font-bold text-white shadow-lg z-20" data-id="element-124">
                    {index + 1}
                  </div>
                </div>

                <h3 className="text-xl font-bold mb-4 text-svt-text" data-id="element-125">
                  {t(step.titleKey)}
                </h3>
                <p className="text-svt-text-muted text-sm leading-relaxed font-light" data-id="element-126">
                  {t(step.descKey)}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-svt-pink/20 to-transparent" data-id="element-127"></div>
    </section>;
}